<template>
  <v-row
    justify="center"
    class="ma-2"
  >
    <v-row>
      <v-col>
        <p class="font-weight-bold">
          AGENCY’S AGREEMENT, RELEASE AND INDEMNITY
        </p>
        <p>TO:    Altruvest Charitable Services ("<span class="font-weight-bold">Altruvest</span>")</p>
        <p>AND TO:   The Directors and Officers of Altruvest</p>
        <p>
          In consideration of our participation in BoardMatch® Fundamentals and/or BoardMatch Leaders (collectively, the "<span class="font-weight-bold">Program</span>") and for other good and valuable consideration, the receipt and sufficiency whereof is hereby acknowledged, we hereby:
        </p>
        <p class="ml-4">
          <ol>
            <li class="mb-5">
              agree to participate in the Program and abide by all of the terms and conditions of the Program, including without limitation, the obligations to:
              <ol type="a">
                <li class="mt-2">
                  subject to subsection (b), keep confidential and not disclose to any third party, the resumé, candidate’s profile or personal information of any individual provided to us under the Program;
                </li>
                <li>
                  only use and disclose to our employees and contractors, the resumé, candidate's profile or personal information of any individual provided to us under the Program for the purposes of the Program;
                </li>
                <li>
                  only contact individuals provided to us under the Program for the purposes of the Program; and
                </li>
                <li>
                  maintain directors and officers liability insurance with a reputable insurance company;
                </li>
              </ol>
            </li>
            <li class="mb-5">
              agree that since Altruvest neither pre-screens nor makes any representation or warranty respecting the individuals participating in the Program, we are solely responsible for making our own investigation and review of the individuals referred to us under the Program, particularly if such individuals become our officers, directors, employees or volunteers;
            </li>
            <li class="mb-5">
              agree to abide by Altruvest’s web site Terms of Service, as amended (the “Terms of Service”), a copy of which is posted on the Altruvest web site located at <a href="https://altruvest.org/">www.altruvest.org</a> (including <a href="http://www.boardmatch.org/">www.boardmatch.org</a> ) (the "<span class="font-weight-bold">Site</span>")
            </li>
            <li class="mb-5">
              release and discharge each of you and your respective successors and assigns from and against any and all claims or loss which we may have or could have against you and your respective successors and assigns arising out of or related to the Program, including without limitation, arising out of or related to the collection, use and/or disclosure of personal information provided by us to you, or use of the Site for the purposes outlined in the Terms of Service, and the acts or omissions of any individuals referred to us under the Program; and
            </li>
            <li class="mb-5">
              indemnify each of you and your respective successors and assigns from and against any and all claims or loss which you and your successors and assigns may suffer or incur arising out of or related to our participation in the Program, including, without limitation, arising out of or related to the collection, use and/or disclosure of personal information provided by us to you, or use of the Site for the purposes outlined in the Terms of Service, and the acts or omissions of any individuals referred to us under the Program.
            </li>
          </ol>
        </p>
      </v-col>
    </v-row>
    <p>
      <v-checkbox
        v-model="isAgreed"
        class="large"
        label="I agree to the above terms and conditions."
        :readonly="!isSelf || readOnly"
        :style="readOnly ? 'pointer-events: none' : ''"
      />
    </p>
    <v-row>
      <v-col
        style="background-color: #ffffe6;"
        class="ml-3 mr-3"
      >
        <span>By clicking “I Agree”, I acknowledge that: I have read the terms stated above; I have authority to bind the Agency; I intend to form a legally binding agreement between the Agency and Altruvest, and any related Altruvest program co-operator listed above (i.e. Volunteer Calgary or Volunteer Thunder Bay), if and as applicable; and that the use of our website and the Program are subject to Altruvest’s  <a
          href="https://altruvest.org/BoardMatch/Content/Downloads/Altruvest%20Terms%20of%20Service.pdf"
          target="_blank"
        >Terms of Service</a> and <a
          href="https://altruvest.org/BoardMatch/Content/Downloads/Altruvest%20Privacy%20Policy.pdf"
          target="_blank"
        >Privacy Policy</a>.</span>
      </v-col>
    </v-row>
  </v-row>
</template>

<script>

import { mapState } from 'vuex';

export default {
  components: {
  },
  props:
    {
      isOnboarding: {
        type: Boolean,
        default: false,
      },
      charityRep: {
        type: Object,
        default: () => {},
      },
      readOnly: {
        type: Boolean,
        default: false,
      },
    },

  data: () => ({
    releaseDialog: false,
    isAgreed: false,

  }),
  computed: {
    ...mapState({
      isSelf: (state) => state.auth.isSelf,
    }),
  },
  mounted() {
    this.init();
  },

  methods: {
    init() {
      if (this.charityRep != null && this.charityRep.acceptTermsAndConditions === true) {
        this.isAgreed = true;
      }
    },
    async submit() {
      const patchObjects = [{ op: 'replace', path: '/acceptTermsAndConditions', value: this.isAgreed }];
      const res = await this.$api.charityRep.patch(this.charityRep.id, patchObjects);
      return res;
    },
    async validate() {
      return this.isAgreed;
    },

  },
};
</script>
<style scoped>
  ::v-deep .large div.v-input__control div.v-input__slot .v-label {
    font-size: 30px;
    margin-left: 15px;
  }
    ::v-deep .large div.v-input__control div.v-input__slot .v-input--selection-controls__input i.v-icon {
    font-size: 40px;
  }
  ::v-deep .large div.v-input__control div.v-input__slot .v-input--selection-controls__input div.v-input--selection-controls__ripple {
    height: 40px;
    width: 40px;
    margin-left:4px;
    margin-top: 5px;
  }
</style>
